module.exports = __webpack_public_path__ + "img/awards-8.f90f753.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/awards-8.png
// module id = 187
// module chunks = 1